import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Message } from '../../interfaces/message';
import { DataService } from '../../services/data.service';
import { IconService } from '../../services/icon.service';

@Component({
  selector: 'app-all-messages',
  templateUrl: './all-messages.component.html',
  styleUrls: ['./all-messages.component.scss']
})

export class AllMessagesComponent implements OnInit {
  @Input() messages: Message[] = [];
  @Input() title: string = '';
  @Input() totalMessagesCount: number = 0;
  @Input() pageSize: number = 0;
  @Input() noMessagesText: string = '';
  @Input() pinnedMessagesIds: number[] = [];
  @Input() set iconUrl(value: string) {
    this.iconService.addIconToRegistry({
      key: value,
      path: value,
    });
    this.icon = value;
  };
  @ViewChild('loadMore', { static: true }) loadMoreElement!: ElementRef;

  page: number = 1;
  loading: boolean = false;
  icon: string = '';

  private observer!: IntersectionObserver;
  
  constructor(private dataService: DataService, private iconService: IconService, private elementRef: ElementRef) {}

  ngOnInit() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadMessages();
          this.observer.unobserve(entry.target);
        }
      });
    });

    setTimeout(() => this.observer.observe(this.loadMoreElement.nativeElement), 100)
  }

  loadMessages() {
    if (this.messages.length >= this.totalMessagesCount || this.loading) {
      return;
    }

    this.loading = true;

    this.dataService.getMessages(this.pageSize, this.page, this.pinnedMessagesIds).subscribe({
      next: (data: Message[]) => 
      {
        this.messages = this.messages.concat(data);
        this.page++;
        this.loading = false;

        if (this.messages.length < this.totalMessagesCount) {
          this.observer.observe(this.loadMoreElement.nativeElement);
        }
      },
      error: (e) => console.error(e)
      });
  }
}